import React from 'react';
import { Link } from 'react-router-dom';
import {
  Box,
  Container,
  Typography,
  Paper,
  useTheme,
  Fade,
  Zoom,
  alpha,
  Divider,
  Chip,
  Stepper,
  Step,
  StepLabel,
  Button,
} from '@mui/material';
import { PersonAdd } from '@mui/icons-material';
import AuthForm from '../auth/AuthForm';

const Signup = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        bgcolor: theme.palette.background.default,
        pt: { xs: 12, md: 15 },
        pb: { xs: 4, md: 8 },
      }}
    >
      <Container maxWidth="md">
        <Fade in={true} timeout={800}>
          <Box>
            {/* Header */}
            <Box sx={{ textAlign: 'center', mb: 4 }}>
              <Zoom in={true} timeout={1000}>
                <Box
                  sx={{
                    width: 80,
                    height: 80,
                    borderRadius: '50%',
                    bgcolor: theme.palette.primary.main,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    mx: 'auto',
                    mb: 2,
                    boxShadow: `0 8px 24px ${alpha(theme.palette.primary.main, 0.4)}`,
                  }}
                >
                  <PersonAdd sx={{ fontSize: 40, color: 'white' }} />
                </Box>
              </Zoom>

              <Typography
                variant="h3"
                sx={{
                  fontWeight: 800,
                  fontSize: { xs: '2rem', md: '2.5rem' },
                  mb: 1,
                  color: theme.palette.primary.main,
                  fontFamily: '"Playfair Display", serif',
                }}
              >
                Join Royal Dastinos
              </Typography>

              <Typography variant="body1" sx={{ color: theme.palette.text.secondary, fontSize: '1.1rem' }}>
                Create your account and start exploring amazing destinations
              </Typography>
            </Box>

            {/* Progress Stepper */}
            <Zoom in={true} timeout={1000}>
              <Paper elevation={0} sx={{ p: { xs: 2, md: 3 }, mb: 4, borderRadius: 3, border: `2px solid ${theme.palette.grey[200]}` }}>
                <Stepper activeStep={0} alternativeLabel>
                  <Step><StepLabel>Personal Info</StepLabel></Step>
                  <Step><StepLabel>Account Setup</StepLabel></Step>
                  <Step><StepLabel>Complete</StepLabel></Step>
                </Stepper>
              </Paper>
            </Zoom>

            {/* Auth Form (shared with the AuthModal) */}
            <Zoom in={true} timeout={1200}>
              <Paper elevation={8} sx={{ p: { xs: 3, md: 5 }, borderRadius: 4, border: `2px solid ${theme.palette.grey[200]}` }}>
                <AuthForm initialMode="signup" showToggle={false} />

                <Divider sx={{ my: 3 }}>
                  <Chip label="OR" size="small" />
                </Divider>

                <Box sx={{ textAlign: 'center' }}>
                  <Typography variant="body2" sx={{ color: theme.palette.text.secondary }}>
                    Already have an account?{' '}
                    <Button
                      component={Link}
                      to="/login"
                      variant="text"
                      sx={{ color: theme.palette.primary.main, fontWeight: 700, textTransform: 'none', '&:hover': { bgcolor: alpha(theme.palette.primary.main, 0.1) } }}
                    >
                      Log In
                    </Button>
                  </Typography>
                </Box>
              </Paper>
            </Zoom>

            {/* Additional Info */}
            <Box sx={{ textAlign: 'center', mt: 3 }}>
              <Typography variant="caption" sx={{ color: theme.palette.text.secondary }}>
                By signing up, you agree to our Terms of Service and Privacy Policy
              </Typography>
            </Box>
          </Box>
        </Fade>
      </Container>
    </Box>
  );
};

export default Signup;
